import { render, staticRenderFns } from "./ProjectMenuItem.vue?vue&type=template&id=0573db24&"
import script from "./ProjectMenuItem.vue?vue&type=script&lang=js&"
export * from "./ProjectMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports